<div class="content-container bg-white">
  <h1>{{ 'communicationChannel.survey.title.view' | translate }}</h1>

  <div class="btn-bar" [appHasAnyPermission]="[PermissionKeys.gestionCommunication]">
    <button class="btn btn-primary" [routerLink]="['manage']">
      <span translate="communicationChannel.survey.btn.manageSurveys"></span>
    </button>
  </div>

  @if (surveys.length === 0) {
    <h5>{{ 'communicationChannel.survey.empty' | translate }}</h5>
  } @else if (surveys.length > 0) {
    <div class="communication-channel-list-container">
      @for (survey of surveys; track survey) {
        <div class="list-item-container"
          [routerLink]="[survey.id]">
          <div class="icon-container">
            <img class="icon" src="../assets/icons/communication_channel_survey.svg" alt="icon" height="60px" width="auto">
          </div>
          <div class="content-container">
            <h3 translate>{{ survey['title' + crtLang.toUpperCase()] }}</h3>
            <h6>{{ survey.publicationDate | date }}</h6>
          </div>
        </div>
      }
    </div>
  }

</div>
